import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { UserRole } from '../../../interfaces/IWidgetInfo'
import { ButtonQuitStyled } from './ButtonQuitStyled'

type Props = {
    role: UserRole | undefined
    returnMentor: () => void,
    disabled?: boolean,
    isMentor?: boolean
}

const ButtonQuit = ({ role, returnMentor, disabled, isMentor}: Props) => {

    let newRole = role;
    if(role === UserRole.STUDENT && isMentor){
        newRole = UserRole.MENTOR1
    }

    return (
        <ButtonQuitStyled disabled={disabled} role={newRole} onClick={returnMentor}>
            <FontAwesomeIcon className="icon" icon={['fas', 'arrow-right-from-bracket']} />
            Salir
        </ButtonQuitStyled>
    )
}

export default ButtonQuit
